<form [formGroup]="shippingAddressForm">
  <!-- Shipping Address container -->
  <ng-container *ngIf="!editClicked">
    <div class="address-container px-1 h-100 rounded">
      <label class="mb-0 mt-3">{{ 'account.details.shipping.address' | translate }}</label>
      <div class="bg-muted ps-0 p-2 m-0 mt-1 rounded">
        <!--displayed address data-->
        <div class="ms-3 d-inline-block font-size-12">
          <div class="details-section-content">{{ shippingAddress.Street }}</div>
          <div class="details-section-content">{{ shippingAddress.Town }}</div>
          <div class="details-section-content">{{ shippingAddress.County }}</div>
          <div class="details-section-content">{{ shippingAddress.Country }}</div>
          <div class="details-section-content">{{ shippingAddress.Postcode }}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--edit inputs of address details-->
  <ng-container *ngIf="editClicked">
    <div class="mb-3">
      <div class="form-floating">
        <input
          class="form-control details-section-content my-1 w-100 rounded my-2 font-size-14"
          type="text"
          id="streetLabel"
          formControlName="Street"
          placeholder="Insert street here"
          [ngClass]="{
            'is-invalid': !!f.Street.errors
          }"
        />
        <label for="streetLabel" class="fw-normal">{{ 'edit.shipping.address' | translate }}</label>
      </div>
      <div *ngIf="f.Street.errors" class="alert alert-danger font-size-12 mb-0 mt-0">
        <div class="error-text" *ngIf="f.Street?.errors?.required || f.Street?.errors?.empty || f.Street?.errors?.whitespace">
          *{{ 'form.street.required' | translate }}
        </div>
        <div class="error-text" *ngIf="f.Street?.errors?.pattern">*{{ 'form.street.pattern' | translate }}</div>
      </div>
    </div>
    <div class="mb-3">
      <div class="form-floating">
        <input
          class="form-control details-section-content my-1 w-100 rounded my-2 font-size-14"
          type="text"
          id="townLabel"
          formControlName="Town"
          placeholder="Insert city here"
          [ngClass]="{
            'is-invalid': !!f.Town.errors
          }"
        />
        <label for="townLabel" class="fw-normal">{{ 'edit.shipping.city' | translate }}</label>
      </div>
      <div *ngIf="f.Town.errors" class="alert alert-danger font-size-12 mb-0 mt-0">
        <div class="error-text" *ngIf="f.Town?.errors?.required || f.Town?.errors?.empty || f.Town?.errors?.whitespace">
          *{{ 'form.city.required' | translate }}
        </div>
        <div class="error-text" *ngIf="f.Town?.errors?.pattern">*{{ 'form.city.pattern' | translate }}</div>
      </div>
    </div>
    <fgb-country-and-regions-accounts
      [SeparateRow]="true"
      [Form]="shippingAddressForm"
      [RegionLabel]="'State'"
    ></fgb-country-and-regions-accounts>

    <div>
      <div class="form-floating">
        <input
          class="form-control details-section-content my-1 w-100 rounded my-2 font-size-14"
          type="text"
          id="postCodeLabel"
          formControlName="Postcode"
          placeholder="Insert zip code here"
          [ngClass]="{
            'is-invalid': !!f.Postcode.errors
          }"
        />
        <label for="postCodeLabel" class="fw-normal">{{ 'edit.shipping.zip.code' | translate }}</label>
      </div>
      <div *ngIf="f.Postcode.errors" class="alert alert-danger font-size-12 mb-0 mt-0">
        <div
          class="error-text"
          *ngIf="f.Postcode?.errors?.required || f.Postcode?.errors?.empty || f.Postcode?.errors?.whitespace"
        >
          *{{ 'form.postcode.required' | translate }}
        </div>
        <div class="error-text" *ngIf="f.Postcode?.errors?.pattern">*{{ 'form.postcode.pattern' | translate }}</div>
      </div>
    </div>
  </ng-container>
  <!-- edit, cancel and save buttons -->
  <button
    type="button"
    class="mb-2 mt-3 d-block mx-auto border-0 text-white bg-primary rounded font-size-14"
    *ngIf="!editClicked"
    (click)="editShippingDetails()"
  >
    {{ 'edit.shipping.form.edit.btn' | translate }}
  </button>
  <ng-container *ngIf="editClicked">
    <div class="d-flex align-items-center justify-content-end">
      <button class="mb-2 mt-3 d-block border-0 text-danger bg-transparent rounded font-size-14" (click)="cancelEdit()">
        {{ 'edit.shipping.form.cancel.btn' | translate }}
      </button>
      <button
        class="mb-2 mt-3 d-block border-0 text-white bg-success rounded font-size-14"
        [ngClass]="disableIfFormIncomplete()"
        [disabled]="shippingAddressForm.invalid"
        (click)="saveChanges()"
      >
        {{ 'edit.shipping.form.save.btn' | translate }}
      </button>
    </div>
  </ng-container>
</form>
